import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useMemo } from 'react';
import { typedFetch } from '../typedFetch';
import './CreateTicket.scss';
import '../ErrorLog/ErrorLog.scss';
export const CreateTicket = ({ appendToErrorLog, }) => {
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState(localStorage.getItem('email')?.toLowerCase() ?? '');
    const [name, setName] = useState(localStorage.getItem('name') ?? '');
    useEffect(() => {
        if (!email.includes('@') || !email.includes('.')) {
            return;
        }
        typedFetch('get-name-from-email', { body: { email } })
            .then((result) => {
            if (result.success) {
                setName(result.name);
            }
        })
            .catch((error) => {
            appendToErrorLog(`Unexpected error while attempting to match up email with name: ${String(error['message'])}`);
        });
    }, [email, appendToErrorLog]);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const allDepartments = useMemo(() => JSON.parse(document.querySelector('[data-data]').textContent), []);
    const [department, setDepartment] = useState(allDepartments[0]);
    const [requestedCompletionDate, setRequestedCompletionDate] = useState(() => {
        const date = new Date();
        date.setDate(date.getDate() + 7);
        const [months, days, year,] = date.toLocaleDateString('en-US').split('/');
        return `${year}-${months}-${days}`;
    });
    const [images, setImages] = useState([]);
    const submit = (e) => {
        e.preventDefault();
        if (loading) {
            return;
        }
        if (department === '') {
            appendToErrorLog('Please choose a department to send your ticket to');
            return;
        }
        if (new Date(requestedCompletionDate) < new Date(new Date().toLocaleDateString('en-US'))) {
            appendToErrorLog('Requested completion date must not be in the past');
            return;
        }
        setLoading(true);
        // This will set a date at midnight UTC at the start of the day
        const date = new Date(requestedCompletionDate);
        // Adding one day from midnight UTC produces a time of 6 PM or 7 PM in the Central timezone, which is fine
        date.setDate(date.getDate() + 1);
        const requestedCompletionTimestamp = date.getTime();
        const formData = new FormData();
        formData.append('email', email);
        formData.append('name', name);
        formData.append('title', title);
        formData.append('description', description);
        formData.append('department', department);
        formData.append('requestedCompletionTimestamp', String(requestedCompletionTimestamp));
        for (const image of images) {
            formData.append('images', image);
        }
        typedFetch('create-ticket', {
            body: formData,
        }, 'no-auth-needed')
            .then((result) => {
            if (result.success) {
                localStorage.setItem('email', email);
                window.location.href = `/tickets/${result.ticketId}?requester_token=${result.requesterToken}`;
            }
            else {
                appendToErrorLog(`Error while creating ticket: ${result.reason}`);
            }
        })
            .catch((error) => {
            appendToErrorLog(`Unexpected error while creating ticket: ${String(error['message'])}`);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    return (_jsxs("form", { className: `create-ticket${loading ? ' loading' : ''}`, onSubmit: submit, children: [_jsx("h2", { children: "Create Ticket" }), _jsxs("div", { className: "labeled-input", children: [_jsx("label", { children: "Email" }), _jsx("div", { children: _jsx("input", { required: true, type: "email", value: email, onChange: (e) => { setEmail(e.currentTarget.value.toLowerCase()); } }) })] }), _jsxs("div", { className: "labeled-input", children: [_jsx("label", { children: "Name" }), _jsx("div", { children: _jsx("input", { required: true, value: name, onChange: (e) => { setName(e.currentTarget.value); } }) })] }), _jsxs("div", { className: "labeled-input department", children: [_jsx("label", { children: "Department" }), _jsx("div", { children: _jsx("select", { value: department, onChange: (e) => { setDepartment(e.currentTarget.value); }, children: allDepartments.map(allDepartment => _jsx("option", { children: allDepartment }, allDepartment)) }) })] }), _jsxs("div", { className: "labeled-input", children: [_jsx("label", { children: "Ticket title" }), _jsx("div", { children: _jsx("input", { required: true, value: title, onChange: (e) => { setTitle(e.currentTarget.value.slice(0, 60)); } }) })] }), _jsx("label", { className: "description", children: "Description" }), _jsx("textarea", { required: true, value: description, placeholder: "Describe the issue to be fixed. If it's relevant, include the room number or location.", onChange: (e) => { setDescription(e.currentTarget.value); } }), _jsxs("div", { className: "labeled-input requested-completion", children: [_jsx("label", { children: "Requested Completion" }), _jsx("div", { children: _jsx("input", { required: true, type: "date", value: requestedCompletionDate, onChange: (e) => { setRequestedCompletionDate(e.currentTarget.value); } }) })] }), _jsxs("div", { className: "labeled-input", children: [_jsx("label", { children: "Attach Images (optional)" }), _jsxs("div", { children: [_jsx("input", { type: "file", accept: "image/*", multiple: true, onChange: (e) => {
                                    const files = [...e.currentTarget.files ?? []];
                                    if (files.length > 10) {
                                        appendToErrorLog('Maximum 10 images allowed');
                                        return;
                                    }
                                    setImages(files);
                                } }), images.length > 0 && (_jsxs("div", { style: { marginTop: '8px', fontSize: '0.9em' }, children: [images.length, " image", images.length !== 1 ? 's' : '', " selected"] }))] })] }), _jsx("button", { children: "Submit" })] }));
};
